import { useState, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Translate from '../../i18n/Translate'

import { I18nContext } from '../../context/I18nProvider'
import api from '../../api'

//SVGs
import WarningSvg from '../../components/svg/WarningSvg'

//Intersection
import { useInView } from 'react-intersection-observer'

const ReservationForm = ({ nameItinerary, idItinerary }) => {
    const { language } = useContext(I18nContext)

    const { t } = useTranslation()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'onChange',
    })

    const [txtAreaClick, setTxtAreaClick] = useState(false)
    const [sendedForm, setSendedForm] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState({
        loading: false,
        error: null,
        response: null,
    })

    const [formulario, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    useEffect(() => {
        if (isSubmitting.response) {
            setSendedForm(isSubmitting.response.status)
            //Si la respuesta es TRUE reseteo el formulario
            isSubmitting.response.status && reset()
        }
    }, [isSubmitting])

    //   Al momento de hacer submit
    const onSubmit = async (data) => {
        // creamos un estado de carga
        setIsSubmitting({ loading: true, error: null })

        // console.log({ ...data, nameItinerary, idItinerary, language })

        // Espermos la respuesta del servidor
        try {
            const apiData = await api.contact.itinerary({ ...data, nameItinerary, idItinerary, language })
            setIsSubmitting({ loading: false, response: apiData })
        } catch (error) {
            console.error(error)
            setIsSubmitting({ loading: false, error: error })
        }
    }

    // Registro al useForm hook de cada input, aca se pasan los parametros de validacion para cada campo, asi como los mensajes de error que luego son usados en los span.

    let nameRegistration = register('name', {
        required: `${t('form.requiredField')}`,
        pattern: {
            value: /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g, //acepta tildes y ñ, Ñ,
            message: `${t('form.wrongField')}`,
        },
    })

    let emailRegistration = register('email', {
        required: `${t('form.requiredField')}`,
        pattern: {
            value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            message: `${t('form.wrongField')}`,
        },
    })

    let phoneRegistration = register('phone', {
        required: `${t('form.requiredField')}`,
        pattern: {
            value: /^[0-9]+$/,
            message: `${t('form.wrongField')}`,
        },
        minLength: {
            value: 10,
            message: `${t('form.minChars', { num: 10 })}. ${t('form.phoneRequirements')}`,
        },
        maxLength: {
            value: 10,
            message: `${t('form.maxChars', { num: 10 })}. ${t('form.phoneRequirements')}`,
        },
    })

    let issueRegistration = register('issue', {
        required: `${t('form.requiredField')}`,
    })

    let messageRegistration = register('message', {
        required: `${t('form.requiredField')}`,
        minLength: {
            value: 10,
            message: `${t('form.minChars', { num: 10 })}`,
        },
        maxLength: {
            value: 1000,
            message: `${t('form.maxChars', { num: 1000 })}`,
        },
    })

    let newsletterRegistration = register('isSubcritedNewLetter')

    let emailCopyRegistration = register('sendEmailCopy')

    const handleTextArea = () => {
        setTxtAreaClick(true)
    }

    return (
        <form
            className={`contact-form reservation-form animate slide-right ${inView ? 'in-view' : ''}`}
            ref={formulario}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
        >
            <div className="input-group">
                <label htmlFor="name">
                    <Translate langkey="form.labels.name" />
                </label>

                <input
                    {...nameRegistration}
                    type="text"
                    id="name"
                    autoComplete="off"
                    aria-invalid={errors.name ? 'true' : 'false'}
                />
                {errors.name && (
                    <span className="error-msg" role="alert">
                        {errors.name.message}
                    </span>
                )}
                {errors.name && (
                    <span className="error-icon">
                        <WarningSvg />
                    </span>
                )}
            </div>

            <div className="input-group">
                <label htmlFor="email">
                    <Translate langkey="form.labels.email" />
                </label>
                <input
                    {...emailRegistration}
                    type="email"
                    id="email"
                    autoComplete="off"
                    aria-invalid={errors.email ? 'true' : 'false'}
                />
                {errors.email && (
                    <span className="error-msg" role="alert">
                        {errors.email.message}
                    </span>
                )}
                {errors.email && (
                    <span className="error-icon">
                        <WarningSvg />
                    </span>
                )}
            </div>

            <div className="input-group">
                <label htmlFor="phone">
                    <Translate langkey="form.labels.phone" />
                </label>

                <input
                    {...phoneRegistration}
                    type="tel"
                    id="phone"
                    autoComplete="off"
                    aria-invalid={errors.phone ? 'true' : 'false'}
                />
                {errors.phone && (
                    <span className="error-msg" role="alert">
                        {errors.phone.message}
                    </span>
                )}
                {errors.phone && (
                    <span className="error-icon">
                        <WarningSvg />
                    </span>
                )}
            </div>

            <div className="input-group">
                <label htmlFor="issue">
                    <Translate langkey="form.labels.issue" />
                </label>
                <input
                    {...issueRegistration}
                    type="text"
                    id="issue"
                    autoComplete="off"
                    aria-invalid={errors.issue ? 'true' : 'false'}
                />
                {errors.issue && (
                    <span className="error-msg" role="alert">
                        {errors.issue.message}
                    </span>
                )}
                {errors.issue && (
                    <span className="error-icon">
                        <WarningSvg />
                    </span>
                )}
            </div>

            <div className="input-group">
                <label htmlFor="message">
                    <Translate langkey="form.labels.message" />
                </label>
                <textarea
                    {...messageRegistration}
                    id="message"
                    autoComplete="off"
                    aria-invalid={errors.message ? 'true' : 'false'}
                    className={`textarea ${txtAreaClick ? 'has-been-active' : ''}`}
                    onClick={handleTextArea}
                    onFocus={handleTextArea}
                />
                {errors.message && (
                    <span className="error-msg" role="alert">
                        {errors.message.message}
                    </span>
                )}
                {errors.message && (
                    <span className="error-icon">
                        <WarningSvg />
                    </span>
                )}
            </div>

            <div className="btn-checkbox-container">
                <div className="checkbox">
                    <div className="checkbox-1">
                        <label htmlFor="newsletter">
                            <Translate langkey="form.labels.newsletter" />
                        </label>
                        <input {...newsletterRegistration} type="checkbox" id="newsletter" />
                    </div>
                    <div className="checkbox-2">
                        <label htmlFor="emailCopy">
                            <Translate langkey="form.labels.emailCopy" />
                        </label>
                        <input {...emailCopyRegistration} type="checkbox" id="emailCopy" />
                    </div>
                </div>
                {isSubmitting.loading ? (
                    <span className="sended-form loading">
                        <Translate langkey="form.loadingMsg" />
                    </span>
                ) : sendedForm ? (
                    <span className="sended-form">
                        <Translate langkey="form.sendedMsg" />
                    </span>
                ) : (
                    <span className="sended-form error">
                        {isSubmitting.error && !isSubmitting.response && <Translate langkey="form.errorMsg" />}
                    </span>
                )}
                <button className="submit-btn" type="submit">
                    <span>
                        <Translate langkey="mice.contact.form.submit" />
                    </span>
                </button>
            </div>
        </form>
    )
}

export default ReservationForm
